module.exports = __webpack_public_path__ + "img/sticky-fill.8d525872.svg";